<file-upload-status
  [progress]="componentConfig?.rowData?.[0]?.uploadProgress ?? 0"
  [progressBarItem]="componentConfig?.rowData"
  (cancelUploadId)="
    componentConfig?.callback?.(
      componentConfig?.rowData ?? [],
      'cancel_upload',
      componentConfig?.columnKey ?? ''
    )
  "
  class="status_bar_upload"
></file-upload-status>
